<template>
  <div id="persona">
    <div class="row">
      <LmSuperPowerSelect
        class="col-12 col-lg-6"
        :data="lmSuperPowerSelects.tiposDocumentos.selectOptions"
        :tbColumns="lmSuperPowerSelects.tiposDocumentos.tbColumns"
        label="Tipo Documento"
        @values="updateTipoDocumento"
        :v="validation.tipoDocumento"
        :model="sanitizeModel(form.idTipoDocumento)"
        :disabled="isOnEditMode"
      />
      <LmNumberInput
        class="col-12 col-lg-6"
        v-model="form.numero"
        :v="validation.numero"
        label="Número de Documento"
        placeholder="Número de Documento"
        :disabled="isOnEditMode"
        />
    </div>
    <div class="row">
      <LmTextInput
        class="col-12 col-lg-6"
        v-model="form.nombre"
        :v="validation.nombre"
        label="Nombre"
        placeholder="Nombre"
        :disabled="isOnEditMode"
        />
      <LmTextInput
        class="col-12 col-lg-6"
        v-model="form.apellido"
        :v="validation.apellido"
        label="Apellido"
        placeholder="Apellido"
        :disabled="isOnEditMode"
        />
    </div>
    <div class="row">
      <LmEmailInput
        class="col-12 col-lg-6"
        v-model="form.emailIniciador"
        :v="validation.emailIniciador"
        label="Email"
        placeholder="Email"
        :disabled="isOnEditMode"
        />
    </div>
    <div class="row">
      <LmGooglePlacesAutocomplete
        class="col-12"
        label="Direccion"
        @placeChanged="placeChanged"
        @inputLmGooglePlacesAutocomplete="inputLmGooglePlacesAutocomplete"
        :disabled="isOnEditMode"
        :value="form.direccionIniciador.formattedAddress"
        :v="validation.direccionIniciador.formattedAddress"
      />
      <LmLeaFletMap
        :markerLatLng="markerLatLng"
        :centerMapCoordinate="markerLatLng"
        class="mb-3 col-12"
        />
    </div>
  </div>
</template>

<script>
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmGooglePlacesAutocomplete from '@/components/LmGooglePlacesAutocomplete.vue'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
export default {
  mixins: [lmSuperPowerSelectHelper],
  data () {
    return {
      lmSuperPowerSelects: {
        tiposDocumentos: {
          selectOptions: [],
          tbColumns: [
            { title: 'id', data: 'id' },
            { title: 'Tipo', data: 'name' }
          ]
        }
      }
    }
  },
  computed: {
    markerLatLng: {
      get () {
        return this.form.direccionIniciador.latLong.length ? this.form.direccionIniciador.latLong : []
      },
      set () {}
    }
  },
  components: {
    LmSuperPowerSelect,
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmGooglePlacesAutocomplete,
    LmLeaFletMap
  },
  props: {
    validation: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({})
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    placeChanged (place) {
      const latLong = [
        place.geometry.location.lat(),
        place.geometry.location.lng()
      ]
      this.markerLatLng = latLong
      this.form.direccionIniciador.latLong = latLong
      this.form.direccionIniciador.formattedAddress = place.formatted_address
    },
    inputLmGooglePlacesAutocomplete (value) {
      if (!value) {
        this.markerLatLng = []
        this.form.direccionIniciador.latLong = []
        this.form.direccionIniciador.formattedAddress = ''
      }
    },
    updateTipoDocumento (values) {
      let value = values[0]
      this.form.tipoDocumento = value ? value.name : ''
      this.form.idTipoDocumento = value ? value.id : ''
    },
    sanitizeModel (model) {
      return model ? model.toString() : ''
    }
  },
  mounted () {
    this.getAllLmSuperPowerSelectOptions([
      {
        name: 'tiposDocumentos',
        obj: {
          path: 'codificaciones/tipos_documentos/',
          total: 1000
        }
      }
    ]).then(response => {
      response.forEach(async element => {
        const e = await element
        this.lmSuperPowerSelects[e.name].selectOptions = e.data
      })
    })
  }
}
</script>
